import { reorder } from 'shared/utils'

/** Returns the reordered visible ids for a drag-end event, or null when the drop is a no-op (e.g. dropped outside the list). */
export function applyDragEnd(order: string[], activeId: string, overId: string | null | undefined): string[] | null {
  if (!overId || activeId === overId) {
    return null
  }
  const oldIndex = order.indexOf(activeId)
  const newIndex = order.indexOf(overId)
  if (oldIndex === -1 || newIndex === -1) {
    return null
  }
  return reorder(order, oldIndex, newIndex)
}

export function moveIdToTop(order: string[], id: string): string[] | null {
  const index = order.indexOf(id)
  if (index === -1) {
    return null
  }
  const next = [...order]
  next.splice(index, 1)
  next.unshift(id)
  return next
}

export function moveIdToBottom(order: string[], id: string): string[] | null {
  const index = order.indexOf(id)
  if (index === -1) {
    return null
  }
  const next = [...order]
  next.splice(index, 1)
  next.push(id)
  return next
}

/**
 * Expands a reordered list of visible ids to the full post list: visible slots take the new
 * visible order, posts hidden by the network filter keep their positions.
 */
export function mergeVisibleOrder(allIdsInOrder: string[], nextVisibleIds: string[]): string[] {
  const visible = new Set(nextVisibleIds)
  let visibleIndex = 0
  return allIdsInOrder.map(id => (visible.has(id) ? nextVisibleIds[visibleIndex++] : id))
}
